export const quickIssues = [
  {
    id: "quick-cant",
    icon: "ri-error-warning-line",
    title: "打开就提示看不了",
    desc: "页面能打开，但视频区域一直黑屏或显示错误，通常和线路、解码或浏览器支持有关。",
    anchor: "#cant-watch",
    tag: "看不了",
  },
  {
    id: "quick-lag",
    icon: "ri-loader-4-line",
    title: "播放中一直卡顿",
    desc: "画面转圈、声音断断续续，多由网络带宽、后台占用或画质选择过高引起。",
    anchor: "#lag",
    tag: "卡顿",
  },
  {
    id: "quick-player",
    icon: "ri-play-circle-line",
    title: "不清楚用什么播放器",
    desc: "浏览器、专业播放器、手机 App 各有适用场景，选对了大多数播放问题会直接消失。",
    anchor: "#players",
    tag: "播放器",
  },
  {
    id: "quick-download",
    icon: "ri-download-2-line",
    title: "下载后不会用",
    desc: "下载的文件放哪、用什么打开、电视盒子怎么播，下面按设备一步步说清楚。",
    anchor: "#download",
    tag: "下载",
  },
];

export const issueCategories = [
  { id: "all", label: "全部" },
  { id: "play", label: "播放问题" },
  { id: "quality", label: "画质与声音" },
  { id: "network", label: "网络卡顿" },
  { id: "device", label: "设备与下载" },
];

export const issueList = [
  {
    id: "i1",
    category: "play",
    title: "点击播放后视频区域一直是黑的",
    symptom: "有播放按钮，点击后没有任何画面，进度条也不动",
    cause: "浏览器禁用了自动播放或硬件加速异常",
    fix: "先点击一次静音图标再播放；到浏览器设置里关闭“使用硬件加速”，重启浏览器后重试。",
  },
  {
    id: "i2",
    category: "play",
    title: "提示“当前格式不支持”或“解码失败”",
    symptom: "能加载出画面但立刻报格式错误",
    cause: "所用播放器缺少对应视频编码的解码能力",
    fix: "换用系统自带播放器或 VLC 这类内置解码较多的播放器，再重新打开文件。",
  },
  {
    id: "i3",
    category: "play",
    title: "播放按钮点了没反应",
    symptom: "按钮有反馈但没有进入播放状态",
    cause: "页面脚本被广告拦截插件拦下",
    fix: "暂时关闭该站点的广告拦截或隐私插件，刷新页面后再点一次播放。",
  },
  {
    id: "i4",
    category: "quality",
    title: "有声音但画面卡住不动",
    symptom: "音频正常，画面冻结在某一帧",
    cause: "显卡与当前画质档位不匹配",
    fix: "把清晰度先降到 720P 或“自动”，等画面追上后再逐步调高。",
  },
  {
    id: "i5",
    category: "quality",
    title: "画面正常但没有声音",
    symptom: "视频在走，音量开到最大仍无声",
    cause: "音轨被静音或输出设备选错",
    fix: "检查播放器自身的静音按钮与电脑的输出设备，确认没有被切到其他音频通道。",
  },
  {
    id: "i6",
    category: "quality",
    title: "字幕对不上或完全不显示",
    symptom: "字幕延迟、乱码或干脆没有",
    cause: "字幕编码与视频不匹配或未加载",
    fix: "优先选择内嵌字幕的版本；外挂字幕请在播放器里指定正确的字幕编码（常见为 UTF-8）。",
  },
  {
    id: "i7",
    category: "network",
    title: "每到同一时间就卡",
    symptom: "白天流畅，晚上高峰期频繁转圈",
    cause: "晚间网络拥堵或运营商限速",
    fix: "把清晰度设为自动，避开高峰时段观看，或改用手机热点对比是否为宽带问题。",
  },
  {
    id: "i8",
    category: "network",
    title: "进度条缓冲总停在某个百分比",
    symptom: "缓冲很慢，长时间停在同一个位置",
    cause: "当前线路对该地区不稳定",
    fix: "切换其他播放线路，或清除浏览器缓存后重新进入播放页。",
  },
  {
    id: "i9",
    category: "device",
    title: "手机上能播，电视上打不开",
    symptom: "同一内容在手机正常，电视盒子无法播放",
    cause: "电视端浏览器内核老旧，不支持新版播放页面",
    fix: "电视端改用第三方播放器或用手机投屏，避免直接用电视自带浏览器打开。",
  },
  {
    id: "i10",
    category: "device",
    title: "下载完成后无法打开文件",
    symptom: "文件存在但双击没有反应",
    cause: "下载未完成或文件扩展名被隐藏",
    fix: "确认下载进度已到 100%，再检查文件名是否带有正确的扩展名，用播放器手动打开该文件。",
  },
];

export const cantWatchSteps = [
  {
    step: "01",
    title: "先确认是线路问题还是本地问题",
    desc: "换一个播放线路再试一次。如果其他线路能正常播放，说明是原线路不稳定，不必折腾本地设置。",
  },
  {
    step: "02",
    title: "刷新并清掉过期的页面缓存",
    desc: "按 Ctrl + Shift + R（Mac 为 Command + Shift + R）强制刷新一次，清掉可能残留的旧播放组件。",
  },
  {
    step: "03",
    title: "临时关闭广告拦截类插件",
    desc: "不少“点了没反应”都来自插件误拦，把该站点加入白名单，再刷新页面重新点击播放。",
  },
  {
    step: "04",
    title: "换一个浏览器或专业播放器",
    desc: "内核较新的浏览器对播放组件支持更好，遇到复杂编码时直接改用 VLC 等专业播放器最省事。",
  },
  {
    step: "05",
    title: "检查网络与地区限制",
    desc: "切换到其他网络（如手机热点）对比。如果只有原网络无法访问，通常是网络环境本身的限制。",
  },
];

export const cantWatchCauses = [
  { title: "页面能开但视频黑屏", desc: "多为硬件加速或自动播放被拦截，按上面第 2、3 步处理。" },
  { title: "提示地区不可用", desc: "内容可能对部分网络环境有限制，换网络后再判断。" },
  { title: "整站都打不开", desc: "通常是本地网络或 DNS 问题，与单个视频无关。" },
  { title: "只有某个视频打不开", desc: "大概率是该视频的线路问题，换线路即可。" },
];

export const lagReasons = [
  {
    key: "带宽不足",
    level: "最常见",
    desc: "观看 1080P 一般需要相对稳定的带宽，多人共用网络时会明显紧张。",
    action: "把清晰度设为“自动”，或关闭同一网络下正在下载、上传的设备。",
  },
  {
    key: "后台程序占用",
    level: "常见",
    desc: "系统更新、云盘同步、直播软件会在后台持续占用网速与显卡资源。",
    action: "播放前关闭后台下载与同步任务，再刷新播放页。",
  },
  {
    key: "画质档位过高",
    level: "常见",
    desc: "强制选择 4K 或超清，而设备或网络跟不上，就会频繁缓冲。",
    action: "先降到 720P 播放，确认流畅后再逐级往上调。",
  },
  {
    key: "浏览器缓存过多",
    level: "偶尔",
    desc: "长期未清理的缓存会让播放组件加载变慢。",
    action: "清理浏览器缓存与 Cookie 后重新打开。",
  },
  {
    key: "设备性能偏低",
    level: "视设备而定",
    desc: "老旧设备解码高码率视频会力不从心，表现为画面掉帧。",
    action: "降低清晰度，或改用性能更好的设备 / 专业播放器。",
  },
];

export const bandwidthTips = [
  { quality: "480P 标清", need: "较低，几乎不挑网络", scene: "手机流量、弱网环境" },
  { quality: "720P 高清", need: "中等，普通宽带足够", scene: "日常观看的稳妥选择" },
  { quality: "1080P 超清", need: "较高，需较稳定带宽", scene: "Wi-Fi 环境、大屏观看" },
  { quality: "4K 极致", need: "很高，且吃设备性能", scene: "设备与网络都富余时再选" },
];

export const players = [
  {
    id: "p1",
    icon: "ri-chrome-line",
    name: "新版浏览器",
    tag: "零安装首选",
    best: "电脑临时观看、不想装软件",
    pros: ["无需安装，打开即用", "对主流画质兼容好", "操作门槛最低"],
    cons: ["复杂编码偶有兼容问题", "长时间播放占用较高"],
    accent: "primary",
  },
  {
    id: "p2",
    icon: "ri-play-circle-line",
    name: "VLC 播放器",
    tag: "全能兜底",
    best: "下载到本地、格式五花八门",
    pros: ["内置解码极全", "免费开源跨平台", "外挂字幕方便"],
    cons: ["界面偏工具化", "在线播放体验一般"],
    accent: "accent",
  },
  {
    id: "p3",
    icon: "ri-smartphone-line",
    name: "手机本地播放器",
    tag: "移动端推荐",
    best: "手机看下载好的影片",
    pros: ["手势控制顺手", "支持后台播放", "省电优化更好"],
    cons: ["不同系统版本差异大", "部分需在应用内切换解码"],
    accent: "secondary",
  },
  {
    id: "p4",
    icon: "ri-tv-2-line",
    name: "电视端播放器",
    tag: "大屏方案",
    best: "电视盒子或智能电视本地播放",
    pros: ["遥控器适配好", "大屏观影更沉浸", "支持外接硬盘"],
    cons: ["安装来源需甄别", "配置门槛略高"],
    accent: "primary",
  },
];

export const downloadDevices = [
  {
    id: "phone",
    label: "手机",
    icon: "ri-smartphone-line",
    steps: [
      "在浏览器中完成下载后，先到“下载内容”里确认进度已到 100%。",
      "安卓设备文件多在“Download”文件夹；iOS 建议保存到“文件”App 便于管理。",
      "用系统自带的视频应用或第三方本地播放器打开，遇到无声再切换解码方式。",
    ],
    notes: ["注意剩余存储空间，长期缓存可定期清理", "避免在下载中途切换网络"],
  },
  {
    id: "pc",
    label: "电脑",
    icon: "ri-computer-line",
    steps: [
      "默认保存位置通常是“下载”文件夹，可在浏览器下载记录中点击“在文件夹中显示”。",
      "双击无法打开时，右键选择“打开方式”，指定 VLC 等专业播放器。",
      "若文件名缺少扩展名，请手动补全后再用播放器打开。",
    ],
    notes: ["下载前确认磁盘空间充足", "外挂字幕与视频放同一目录最省事"],
  },
  {
    id: "tv",
    label: "电视盒子",
    icon: "ri-tv-2-line",
    steps: [
      "优先把文件拷到 U 盘，再插到电视盒子上用文件管理器读取。",
      "盒子上安装的播放器要选择支持常见编码的版本，避免装到仅支持部分格式的简化版。",
      "若盒子无法识别文件，多为格式不支持，可先在电脑上转码再拷贝。",
    ],
    notes: ["U 盘建议用常见格式（如 FAT32 / exFAT）", "投屏是更省事的替代方案"],
  },
];

export const settingsTips = [
  {
    icon: "ri-speed-up-line",
    title: "画质先“自动”再微调",
    desc: "把清晰度交给自动模式，播放稳定后再手动提高到 1080P，避免一上来就卡在超清档。",
  },
  {
    icon: "ri-router-line",
    title: "能连 Wi-Fi 就别用流量",
    desc: "大屏与高清播放对带宽要求更高，Wi-Fi 或网线更稳定，也避免流量超额。",
  },
  {
    icon: "ri-battery-charge-line",
    title: "移动端留意省电模式",
    desc: "部分手机的省电模式会限制后台解码，出现卡顿时可先临时关闭省电模式再播放。",
  },
  {
    icon: "ri-history-line",
    title: "定期清理缓存",
    desc: "每隔一段时间清理一次浏览器缓存，能让播放组件加载更快、减少异常。",
  },
  {
    icon: "ri-timer-line",
    title: "避开高峰时段",
    desc: "晚间高峰网络拥堵明显，对流畅度要求高时可选择其他时段观看。",
  },
  {
    icon: "ri-restart-line",
    title: "异常先从重启开始",
    desc: "重启浏览器、路由器或设备，往往能解决一大半临时性的播放异常。",
  },
];

export const faqs = [
  {
    q: "西瓜影院在线观看为什么总是卡顿？",
    a: "卡顿绝大多数来自三个方向：网络带宽不足、后台程序占用，以及清晰度选择过高。按“先降清晰度、再关后台、最后换网络”的顺序排查，基本能定位到原因。",
  },
  {
    q: "提示“看不了”是不是网站坏了？",
    a: "不一定。先换一条播放线路试试，如果其他线路正常，说明只是原线路暂时不稳定；如果整站都打不开，才更可能是本地网络或 DNS 的问题。",
  },
  {
    q: "下载后用什么播放器打开最好？",
    a: "格式不确定或比较冷门时，优先用 VLC 这类内置解码很全的播放器；如果是手机端，用系统自带或评分较高的本地播放器即可，遇到无声再切换解码方式。",
  },
  {
    q: "手机上能播，为什么电视盒子打不开？",
    a: "电视端浏览器内核往往较老，可能不支持新版播放页面。可以改用支持常见编码的电视播放器，或者直接用手机投屏到电视，通常更省事。",
  },
  {
    q: "播放时有声音但画面不动，怎么办？",
    a: "这是显卡与画质档位不匹配的典型表现。先把清晰度降到 720P 或自动，等画面追上后再逐级调高，一般就能恢复正常。",
  },
  {
    q: "广告拦截插件会影响播放吗？",
    a: "会。部分播放组件会被插件误判并拦截，表现为“点了播放没反应”。把该站点加入白名单后刷新页面即可。",
  },
  {
    q: "480P、720P、1080P 该怎么选？",
    a: "弱网或流量环境选 480P 更稳；日常观看 720P 是兼顾清晰度与流畅度的稳妥选择；Wi-Fi 且设备较好时再上 1080P。",
  },
  {
    q: "页面一直显示加载中怎么办？",
    a: "先强制刷新（Ctrl + Shift + R），仍不行就清理缓存，再换一条线路。如果多次尝试都无效，可换用其他浏览器或稍后再试。",
  },
];

export const heroStats = [
  { value: "4 类", label: "高频问题专区" },
  { value: "10 条", label: "对症解决建议" },
  { value: "3 端", label: "手机 / 电脑 / 电视" },
  { value: "8 问", label: "常见疑问解答" },
];

export const navLinks = [
  { id: "top", label: "首页" },
  { id: "issues", label: "问题速查" },
  { id: "cant-watch", label: "看不了" },
  { id: "lag", label: "卡顿" },
  { id: "players", label: "播放器" },
  { id: "download", label: "下载" },
  { id: "settings", label: "设置建议" },
  { id: "faq", label: "常见问题" },
];